/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListSkillLinksResult,
  ListSkillLinksResult$inboundSchema,
} from "../components/listskilllinksresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListSkillLinksSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSkillLinksSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSkillLinksSecurity = {
  option1?: ListSkillLinksSecurityOption1 | undefined;
  option2?: ListSkillLinksSecurityOption2 | undefined;
};

/**
 * Only return links to this kind of MCP surface.
 */
export const TargetKind = {
  McpServer: "mcp_server",
  MetaMcpServer: "meta_mcp_server",
  OrganizationGateway: "organization_gateway",
} as const;
/**
 * Only return links to this kind of MCP surface.
 */
export type TargetKind = ClosedEnum<typeof TargetKind>;

export type ListSkillLinksRequest = {
  /**
   * Only return links of this skill.
   */
  skillId?: string | undefined;
  /**
   * Only return links to this MCP server.
   */
  mcpServerId?: string | undefined;
  /**
   * Only return links to this gateway.
   */
  metaMcpServerId?: string | undefined;
  /**
   * Only return links to this kind of MCP surface.
   */
  targetKind?: TargetKind | undefined;
  /**
   * Cursor for the next page of skill links.
   */
  cursor?: string | undefined;
  /**
   * The number of skill links to return per page.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListSkillLinksResponse = {
  result: ListSkillLinksResult;
};

/** @internal */
export type ListSkillLinksSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSkillLinksSecurityOption1$outboundSchema: z.ZodMiniType<
  ListSkillLinksSecurityOption1$Outbound,
  ListSkillLinksSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSkillLinksSecurityOption1ToJSON(
  listSkillLinksSecurityOption1: ListSkillLinksSecurityOption1,
): string {
  return JSON.stringify(
    ListSkillLinksSecurityOption1$outboundSchema.parse(
      listSkillLinksSecurityOption1,
    ),
  );
}

/** @internal */
export type ListSkillLinksSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSkillLinksSecurityOption2$outboundSchema: z.ZodMiniType<
  ListSkillLinksSecurityOption2$Outbound,
  ListSkillLinksSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listSkillLinksSecurityOption2ToJSON(
  listSkillLinksSecurityOption2: ListSkillLinksSecurityOption2,
): string {
  return JSON.stringify(
    ListSkillLinksSecurityOption2$outboundSchema.parse(
      listSkillLinksSecurityOption2,
    ),
  );
}

/** @internal */
export type ListSkillLinksSecurity$Outbound = {
  Option1?: ListSkillLinksSecurityOption1$Outbound | undefined;
  Option2?: ListSkillLinksSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSkillLinksSecurity$outboundSchema: z.ZodMiniType<
  ListSkillLinksSecurity$Outbound,
  ListSkillLinksSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListSkillLinksSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListSkillLinksSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSkillLinksSecurityToJSON(
  listSkillLinksSecurity: ListSkillLinksSecurity,
): string {
  return JSON.stringify(
    ListSkillLinksSecurity$outboundSchema.parse(listSkillLinksSecurity),
  );
}

/** @internal */
export const TargetKind$outboundSchema: z.ZodMiniEnum<typeof TargetKind> = z
  .enum(TargetKind);

/** @internal */
export type ListSkillLinksRequest$Outbound = {
  skill_id?: string | undefined;
  mcp_server_id?: string | undefined;
  meta_mcp_server_id?: string | undefined;
  target_kind?: string | undefined;
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSkillLinksRequest$outboundSchema: z.ZodMiniType<
  ListSkillLinksRequest$Outbound,
  ListSkillLinksRequest
> = z.pipe(
  z.object({
    skillId: z.optional(z.string()),
    mcpServerId: z.optional(z.string()),
    metaMcpServerId: z.optional(z.string()),
    targetKind: z.optional(TargetKind$outboundSchema),
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 20),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      skillId: "skill_id",
      mcpServerId: "mcp_server_id",
      metaMcpServerId: "meta_mcp_server_id",
      targetKind: "target_kind",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSkillLinksRequestToJSON(
  listSkillLinksRequest: ListSkillLinksRequest,
): string {
  return JSON.stringify(
    ListSkillLinksRequest$outboundSchema.parse(listSkillLinksRequest),
  );
}

/** @internal */
export const ListSkillLinksResponse$inboundSchema: z.ZodMiniType<
  ListSkillLinksResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListSkillLinksResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listSkillLinksResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillLinksResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillLinksResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillLinksResponse' from JSON`,
  );
}
